import { useGetRegionPageAvailableLocations } from 'api/regions/hooks';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

export const useRegionLocationAvailableItems = () => {
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { data, isLoading } = useGetRegionPageAvailableLocations(selectedRegion);

  return { items: data || [], isLoading };
};
